import { render, staticRenderFns } from "./NewAdminUserModal.vue?vue&type=template&id=6a55f287&scoped=true&"
import script from "./NewAdminUserModal.vue?vue&type=script&lang=js&"
export * from "./NewAdminUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55f287",
  null
  
)

export default component.exports